import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {BootstrapLicenseDataService} from '@core/services';
import {ERROR_PAGES_404_ROUTE} from '@core/constants/navigation';

@Injectable({
  providedIn: 'root'
})
export class NonConformitiesModuleGuard  {
  constructor(
    private router: Router,
    private bootstrapLicenseData: BootstrapLicenseDataService,
  ) { }

  canActivate(): boolean {
    if (this.bootstrapLicenseData.getBootstrapData().modules.discrepancies) {
      return true;
    }

    this.router.navigateByUrl(ERROR_PAGES_404_ROUTE);
    return false;
  }
}
